import { memo } from 'react';

import { cn } from '@/utils/cn';
import { ChevronRight } from 'lucide-react';

interface HideMenuButtonProps {
  isNavCollapsed: boolean;
  toggleNavCollapse: () => void;
}

export const HideMenuButton = memo<HideMenuButtonProps>(({ isNavCollapsed, toggleNavCollapse }) => {
  return (
    <div
      onClick={toggleNavCollapse}
      role="button"
      tabIndex={0}
      aria-label={isNavCollapsed ? 'Expand menu' : 'Collapse menu'}
      className={cn(
        'mx-2 my-1 hidden items-center gap-2 rounded-md md:flex',
        isNavCollapsed ? 'justify-center px-2' : 'px-3',
        'text-secondary-500 py-2 text-[12px]',
        'hover:bg-secondary-400/30 hover:text-typography-100',
        'cursor-pointer transition-colors duration-150'
      )}
    >
      <ChevronRight
        className={cn('h-3.5 w-3.5 transition-transform duration-200', !isNavCollapsed && 'rotate-180')}
        aria-hidden="true"
      />
      {!isNavCollapsed && <span>Collapse</span>}
    </div>
  );
});
